export default function ReceiptModal({ receipt, storeName, store, cashGiven, change, onClose }) {
  const items = receipt?.items || [];
  const total = parseFloat(receipt?.total_amount || 0);
  const bonusUsed = parseFloat(receipt?.bonus_used || 0);
  const bonusEarned = parseFloat(receipt?.bonus_earned || 0);
  const paymentMethod = receipt?.payment_method;

  const PAYMENT_LABELS = { cash:'💵 Готівка', card:'💳 Картка', mixed:'🔀 Змішана', bonus:'🎁 Бонуси' };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        {/* Чек */}
        <div style={styles.receipt}>
          <div style={styles.receiptHeader}>
            <div style={styles.receiptLogo}>🍺</div>
            <div style={styles.receiptStore}>{storeName}</div>
            {store?.legal_name && <div style={styles.receiptSub}>{store.legal_name}</div>}
            {store?.tax_id && <div style={styles.receiptSub}>ЄДРПОУ/ІПН: {store.tax_id}</div>}
            {store?.address && <div style={styles.receiptSub}>{store.address}</div>}
            {store?.phone && <div style={styles.receiptSub}>{store.phone}</div>}
            <div style={styles.receiptSub}>Товарний чек</div>
            <div style={styles.receiptDate}>
              {new Date(receipt?.created_at || Date.now()).toLocaleString('uk-UA', {
                day:'2-digit', month:'2-digit', year:'numeric',
                hour:'2-digit', minute:'2-digit'
              })}
            </div>
            {receipt?.id && (
              <div style={styles.receiptNum}>#{receipt.id.slice(-8).toUpperCase()}</div>
            )}
          </div>

          <div style={styles.receiptDivider} />

          <div style={styles.receiptItems}>
            {items.map((item, i) => (
              <div key={i} style={styles.receiptItem}>
                <div style={styles.receiptItemName}>{item.product_name}</div>
                <div style={styles.receiptItemRow}>
                  <span style={styles.receiptItemQty}>
                    {parseFloat(item.quantity).toFixed(3)} × {parseFloat(item.price).toFixed(2)} ₴
                  </span>
                  <span style={styles.receiptItemTotal}>
                    {parseFloat(item.total).toFixed(2)} ₴
                  </span>
                </div>
              </div>
            ))}
          </div>

          <div style={styles.receiptDivider} />

          <div style={styles.receiptTotals}>
            {bonusUsed > 0 && (
              <div style={styles.receiptRow}>
                <span>🎁 Бонуси списано:</span>
                <span style={{color:'#e53e3e'}}>-{bonusUsed.toFixed(2)} ₴</span>
              </div>
            )}
            <div style={styles.receiptGrandTotal}>
              <span>РАЗОМ</span>
              <span style={{color:'#d97706'}}>{total.toFixed(2)} ₴</span>
            </div>
            <div style={styles.receiptRow}>
              <span>Оплата</span>
              <span>{PAYMENT_LABELS[paymentMethod] || paymentMethod}</span>
            </div>
            {cashGiven > 0 && paymentMethod === 'cash' && (
              <>
                <div style={styles.receiptRow}>
                  <span>Отримано:</span>
                  <span>{parseFloat(cashGiven).toFixed(2)} ₴</span>
                </div>
                <div style={styles.receiptRow}>
                  <span>Решта:</span>
                  <span style={{color:'#059669', fontWeight:'bold'}}>{parseFloat(change).toFixed(2)} ₴</span>
                </div>
              </>
            )}
            {bonusEarned > 0 && (
              <div style={{...styles.receiptRow, color:'#059669', marginTop:'6px'}}>
                <span>🎁 Нараховано бонусів:</span>
                <span>+{bonusEarned.toFixed(2)}</span>
              </div>
            )}
          </div>

          <div style={styles.receiptDivider} />
          <div style={styles.receiptFooter}>{store?.receipt_footer || 'Дякуємо за покупку! 🍺'}</div>
        </div>

        {/* Кнопки */}
        <div style={styles.btns}>
          <button style={styles.printBtn} onClick={() => window.print()}>🖨 Друк</button>
          <button style={styles.newSaleBtn} onClick={onClose}>+ Новий продаж</button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: { position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.85)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:3000, padding:'16px' },
  modal: { width:'340px', maxWidth:'95vw', maxHeight:'90vh', overflow:'auto', display:'flex', flexDirection:'column', gap:'12px' },
  receipt: { background:'#fff', borderRadius:'12px', padding:'24px', color:'#1a202c', fontFamily:'\'Courier New\', monospace' },
  receiptHeader: { textAlign:'center', marginBottom:'12px' },
  receiptLogo: { fontSize:'28px', marginBottom:'4px' },
  receiptStore: { fontSize:'16px', fontWeight:'bold', marginBottom:'2px' },
  receiptSub: { fontSize:'11px', color:'#718096', marginBottom:'2px' },
  receiptDate: { fontSize:'11px', color:'#718096', marginBottom:'2px' },
  receiptNum: { fontSize:'12px', color:'#9a8a6e', fontWeight:'bold' },
  receiptDivider: { borderTop:'1px dashed #cbd5e0', margin:'10px 0' },
  receiptItems: { marginBottom:'4px' },
  receiptItem: { marginBottom:'8px' },
  receiptItemName: { fontSize:'13px', fontWeight:'bold', marginBottom:'2px' },
  receiptItemRow: { display:'flex', justifyContent:'space-between', fontSize:'12px', color:'#9a8a6e' },
  receiptItemQty: {},
  receiptItemTotal: { fontWeight:'bold', color:'#1a202c' },
  receiptTotals: {},
  receiptRow: { display:'flex', justifyContent:'space-between', fontSize:'13px', marginBottom:'4px', color:'#9a8a6e' },
  receiptGrandTotal: { display:'flex', justifyContent:'space-between', fontSize:'18px', fontWeight:'bold', marginBottom:'6px', color:'#1a202c' },
  receiptFooter: { textAlign:'center', fontSize:'12px', color:'#718096', marginTop:'4px' },
  btns: { display:'flex', gap:'10px' },
  printBtn: { flex:1, padding:'12px', background:'#38301f', color:'#fff', border:'none', borderRadius:'10px', cursor:'pointer', fontSize:'14px' },
  newSaleBtn: { flex:2, padding:'12px', background:'#f5a623', color:'#14110c', border:'none', borderRadius:'10px', cursor:'pointer', fontSize:'14px', fontWeight:'bold' },
};
